import {
  AddRateIntoCalculationRequestDto,
  ChangeWishCalculationVehicleRequestDto,
  RemoveRateFromCalculationRequestDto,
  UpdateRateRequestDto,
} from "./wishElement.requestsDto";

const controller = "wish-elements";

export default {
  controller,
  byRate: controller + "/by-rate",
  addRateInCalculation: (dto: AddRateIntoCalculationRequestDto) => controller + `/${dto.wishElementId}/rates/${dto.rateId}/apply`,
  removeRateFromCalculation: (dto: RemoveRateFromCalculationRequestDto) => controller + `/${dto.wishElementId}/rates/${dto.rateId}/unapply`,
  byCalculationVehicle: controller + "/by-calculation-vehicle",
  calculationVehicle: (dto: ChangeWishCalculationVehicleRequestDto) => controller + `/${dto.wishElementId}/calculation-vehicle`,
  updateRate: (dto: UpdateRateRequestDto) => controller + `/${dto.wishElementId}/rate`,
};
